// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"724":"e3db1265","786":"6db5e99b","844":"5b7e1717"}[chunkId] + ".chunk.js";
};